
import axios from "axios";

export default {
  name: "StatisticsView",
  props: {
    dataUrl: {type: String, required: true},
  },
  data() {
    return {
      availableDimensions: [
        {id: 'fos' , label: 'Studienrichtung', selected: false},
        {id: 'specialization', label: 'Vertiefung', selected: false},
        {id: 'degree' , label: 'Studiengang', selected: false},
        {id: 'studyType' , label: 'Studienfach', selected: false},
        {id: 'institute' , label: 'Institut', selected: false},
        {id: 'isAccredited' , label: 'Akkredition', selected: false},
      ],
      selectedDimensions: [],
      isDragging: false,

      isBusy: false,
      error: false,
      showOverlay: true,
      showSemesters: false,
      staticFieldDefinitions: [
        {key: 'total', label: 'Gesamt'},
        {key: 'standardPeriodOfStudy', label: 'RSZ'},
        {key: 'semester1', label: '1', class: 'text-end'},
        {key: 'semester2', label: '2', class: 'text-end'},
        {key: 'semester3', label: '3', class: 'text-end'},
        {key: 'semester4', label: '4', class: 'text-end'},
        {key: 'semester5', label: '5', class: 'text-end'},
        {key: 'semester6', label: '6', class: 'text-end'},
        {key: 'semester7', label: '7', class: 'text-end'},
        {key: 'semester8', label: '8', class: 'text-end'},
        {key: 'semester9', label: '9', class: 'text-end'},
        {key: 'semester10', label: '10', class: 'text-end'},
        {key: 'semester11', label: '11', class: 'text-end'},
        {key: 'semester12', label: '12', class: 'text-end'},
        {key: 'semesterOver12', label: '>12', class: 'text-end'},
      ],
      items: [],
    };
  },
  computed: {
    dimensions() {
      return this.selectedDimensions.map(dim => dim.id);
    },
    dynamicFields() {
      return this.selectedDimensions.map(({id, label}) => ({key: id + 'Name', label}));
    },
    staticFields() {
      if (this.showSemesters) return this.staticFieldDefinitions;
      return this.staticFieldDefinitions.filter((field) => !field.key.startsWith('semester'))
    },
  },
  watch: {
    availableDimensions: {
      handler() {
        this.availableDimensions.sort((a, b) => b.selected - a.selected)
      },
      deep: true
    },
  },
  mounted() {
    window.addEventListener('resize', this.calculateContainerHeight);
  },
  methods: {
    loadTable() {
      this.selectedDimensions = this.availableDimensions.filter(dim => dim.selected)
      this.showOverlay = false;
      this.fetchData(this.dimensions[0]);
    },
    fetchData(dimension) {
      this.isBusy = true;
      this.calculateContainerHeight();

      // reset error state
      this.error = false;

      // fetch data
      axios.get(this.dataUrl, {
        params: {
          dimension: dimension,
        },
      }).then((response) => {
        // set item dimension
        for (const item of response.data.items) {
          item.dimension = dimension;
        }
        // set items
        this.items = response.data.items;
      }).catch((error) => {
        this.error = error;
        this.items = [];
      }).finally(() => {
        this.isBusy = false;
      });
    },
    addItems(item, index, row) {
      item.open = true;
      this.isBusy = true;

      // reset error state
      this.error = false;

      // create filters (set null values to 'null' since axios deletes null params)
      let filters = {
        [item.dimension]: item[item.dimension + 'Id'] ?? 'null',
        ...this.previousDimensions(item).reduce((result, dim) => ({...result, [dim]: item[dim + 'Id'] ?? 'null'}), {})
      };

      // request params
      const params = {
        dimension: this.nextDimension(item),
        filters: filters,
      };

      // fetch data
      axios.get(this.dataUrl, {
        params
      }).then((response) => {
        // set item dimension
        for (const item of response.data.items) {
          item.dimension = params.dimension;
        }
        // add items
        this.items.splice(index + 1, 0, ...response.data.items);
        row?.classList.add('open');
      }).catch((error) => {
        this.error = error;
        this.items = [];
      }).finally(() => {
        this.isBusy = false;
      });
    },
    removeItems(item, index, row) {
      // find count of items to remove
      let count = 0;
      const currentDimensionIndex = this.dimensions.indexOf(item.dimension);
      while (this.items[index + 1 + count] && // while item exists and its dimension index is higher than the current
        this.dimensions.indexOf(this.items[index + 1 + count].dimension) > currentDimensionIndex) {
        count++;
      }

      // remove items
      this.items.splice(index + 1, count);
      item.open = false;
      row?.classList.remove('open');
    },
    blockAnimation() {
      this.isDragging = true;
      this.$nextTick(() => this.isDragging = false);
    },
    rowClicked({ item, index, event }) {
      const row = event?.target?.closest('tr');
      if (!item.open && this.nextDimension(item)) {
        this.addItems(item, index, row);
      }
      else if (item.open) {
        this.removeItems(item, index, row);
      }
    },
    nextDimension(item) {
      return this.dimensions[this.dimensions.indexOf(item.dimension) + 1];
    },
    previousDimensions(item) {
      return this.dimensions.slice(0, this.dimensions.indexOf(item.dimension));
    },
    rowClasses(item, type) {
      if (type !== 'row') return '';

      let classes = [];
      if (!this.isBusy && this.nextDimension(item)) {
        classes.push('chevron-cursor');
        if (item.open) {
          classes.push('open');
        }
      }
      classes.push('level-' + this.dimensions.indexOf(item.dimension));

      return classes;
    },
    calculateContainerHeight() {
      const table = $(this.$refs.table.$el);
      const windowHeight = $(window).height();
      const offsetTop = table.offset().top;
      const footerHeight = $('footer').outerHeight();
      const correction = 18; // due to margins
      const tableHeight = windowHeight - offsetTop - footerHeight - correction;
      table.height(tableHeight);
    },
  },
}
